import { render, staticRenderFns } from "./FrequencyInsightsWidget.vue?vue&type=template&id=6990c78a&"
import script from "./FrequencyInsightsWidget.vue?vue&type=script&lang=js&"
export * from "./FrequencyInsightsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports